import { ValueWithSelection } from './Mask';

export const toValueWithSelection = (chars: string[], start: number, end: number = start): ValueWithSelection => ({
    value: chars.join(''),
    selection: { start, end },
});

export const isSelectionEmpty = (vs: ValueWithSelection) => vs.selection.start === vs.selection.end;
